class SilktideCookieBanner {
  constructor(config) {
    this.config = config;
    this.createWrapper();
    this.createModal();

    if (this.shouldShowBanner()) {
      this.createBanner();
    }
    this.setupEventListeners();
  }

  createWrapper() {
    this.wrapper = document.createElement('div');
    this.wrapper.id = 'silktide-wrapper';
    document.body.insertBefore(this.wrapper, document.body.firstChild);
  }

  createWrapperChild(htmlContent, id) {
    const child = document.createElement('div');
    child.id = id;
    if (htmlContent) child.innerHTML = htmlContent;
    this.wrapper.appendChild(child);
    return child;
  }

  handleCookieChoice(accepted) {
    localStorage.setItem('silktide_completed_choice', 'true');
    if (this.banner) this.banner.remove();
    this.toggleModal(false);

    if (accepted && this.config.cookieTypes) {
      this.config.cookieTypes.forEach(type => {
        if (typeof type.onAccept === 'function') type.onAccept();
      });
    }
    window.dataLayer.push({'event': 'stcm_consent_update'});
  }

  shouldShowBanner() { 
    return localStorage.getItem('silktide_completed_choice') === null; 
  }

  createBanner() {
    this.banner = this.createWrapperChild(this.getBannerContent(), 'silktide-banner');
  }

  getBannerContent() {
    return `
      <p>${this.config.text.banner.description}</p>
      <div class="actions">
        <button class="accept-all st-button--primary">${this.config.text.banner.acceptAllButtonText}</button>
        <button class="reject-all st-button--secondary">${this.config.text.banner.rejectNonEssentialButtonText}</button>
        <button class="preferences-trigger">${this.config.text.banner.preferencesButtonText}</button>
      </div>
    `;
  }

  createModal() {
    // Rebuilt to match your screenshot
    let cookieHtml = this.config.cookieTypes.map(type => `
      <div class="cookie-type-row">
        <div>
          <strong>${type.name}</strong>
          <p style="font-size:12px; margin:4px 0;">${type.description}</p>
        </div>
        <label class="st-switch">
          <input type="checkbox" checked disabled>
          <span class="st-slider"></span>
        </label>
      </div>
    `).join('');

    this.modal = this.createWrapperChild(`
      <div class="st-modal-content">
        <div class="st-modal-header">
          <h3>Customize your cookie preferences</h3>
          <button class="modal-close-x">&times;</button>
        </div>
        <div class="st-modal-body">
          <p>We respect your right to privacy. Your preferences will apply across our website.</p>
          ${cookieHtml}
        </div>
        <div class="st-modal-footer">
          <button class="save-close-btn st-button--primary">Save & Close</button>
        </div>
      </div>
    `, 'silktide-modal');
  }

  toggleModal(show) {
    if (!this.modal) return;
    this.modal.style.display = show ? 'flex' : 'none';
  }

  setupEventListeners() {
    this.banner?.querySelector('.accept-all')?.addEventListener('click', () => this.handleCookieChoice(true));
    this.banner?.querySelector('.reject-all')?.addEventListener('click', () => this.handleCookieChoice(false));
    this.banner?.querySelector('.preferences-trigger')?.addEventListener('click', () => this.toggleModal(true));
    this.modal?.querySelector('.modal-close-x')?.addEventListener('click', () => this.toggleModal(false));
    this.modal?.querySelector('.save-close-btn')?.addEventListener('click', () => this.handleCookieChoice(true));
  }
}

(function() {
  window.silktideCookieBannerManager = {
    updateCookieBannerConfig: (config) => { new SilktideCookieBanner(config); }
  };
})();